import pic1 from './GalleryContent/pic1.jpg';
import pic2 from './GalleryContent/pic2.jpg';
import pic3 from './GalleryContent/pic3.jpg';
import pic4 from './GalleryContent/pic4.jpg';
import pic5 from './GalleryContent/pic5.jpg';
import pic6 from './GalleryContent/pic6.jpg';
import pic7 from './GalleryContent/pic7.jpg';
import pic8 from './GalleryContent/pic8.jpg';
import pic9 from './GalleryContent/pic9.jpg';
import pic10 from './GalleryContent/pic10.jpg';
import pic11 from './GalleryContent/pic11.jpg';
import pic12 from './GalleryContent/pic12.jpg';

export const cardList = [
    {
      link: pic1,
      title: "Details",
      id: 1
    },

    {
      link: pic2,
      title: "Interior",
      id: 2
    },
    {
      link: pic3,
      title: "Details",
      id: 3
    },
  
    {
      link: pic4,
      title: "Details",
      id: 4
    },

    {
        link: pic5,
        title: "Interior",
        id: 5
      },

      {
        link: pic6,
        title: "Guests",
        id: 6
      },

      {
        link: pic7,
        title: "Details",
        id: 7
      },

      {
        link: pic8,
        title: "Details",
        id: 8
      },

      {
        link: pic9,
        title: "Staff",
        id: 9
      },

      {
        link: pic10,
        title: "Details",
        id: 10
      },

      {
        link: pic11,
        title: "Guests",
        id: 11
      },

      {
        link: pic12,
        title: "Interior",
        id: 12
      }
  
  ]
  
  
  